import { status, StatusType } from '../typeStatus'
import { RecomendacionesCVResCoreDto } from './interface'

export const GET_RECOMENDACIONES_CV = 'GET_RECOMENDACIONES_CV'
export const GET_RECOMENDACIONES_CV_SUCCESS = 'GET_RECOMENDACIONES_CV_SUCCESS'
export const GET_RECOMENDACIONES_CV_ERROR = 'GET_RECOMENDACIONES_CV_ERROR'

export interface CvsRecomendados {
  data: RecomendacionesCVResCoreDto[]
}

export const InitialState: RecomendacionesCvState = {
  status: status.initial,
  recomendacionesCv: null,
}
export interface RecomendacionesCvState {
  recomendacionesCv: CvsRecomendados | null
  status: StatusType
}
export interface GetRecomendacionesCv {
  type: typeof GET_RECOMENDACIONES_CV
  payload: null
}

export interface GetRecomendacionesCvSuccess {
  type: typeof GET_RECOMENDACIONES_CV_SUCCESS
  payload: CvsRecomendados
}

export interface GetRecomendacionesCvError {
  type: typeof GET_RECOMENDACIONES_CV_ERROR
  payload: null
}

export type CvsRecomendadosActions = GetRecomendacionesCv | GetRecomendacionesCvSuccess | GetRecomendacionesCvError
